import rootLogger from '@/utils/root-logger';
import {formatUrl} from '@/utils/url-utils';
import JSONbig from 'json-bigint';

const logger = rootLogger.create('fetcher');
const JSONbigString = JSONbig({storeAsString: true});

/* eslint no-throw-literal: "warn" */

const fetchText = async (url, fetchParams, options = {}) => {
  const operation = options.operation;

  if (operation) {
    logger.log('fetch request', { operation, url, fetchParams });
  }

  let response; // so accessible in catch handler
  try {
    const fetch = options.fetch || window.fetch;
    const formattedUrl = formatUrl(url);
    response = await fetch(formattedUrl, fetchParams);

    if (!response.ok) {
      const error = new Error('fetch error, response != OK');
      error.operation = operation;
      error.response = response;
      error.url = formattedUrl;
      error.fetchParams = fetchParams;
      throw error;
    }

    if (!options.quiet && operation) {
      logger.log('fetch success', {operation});
    }
    return await response.text();
  } catch (error) {
    if (!options.quiet && operation) {
      logger.error('fetch failure', {
        operation, url, response, fetchParams, error
      });
    }
    error.url = error.url || url;
    error.fetchParams = error.fetchParams || fetchParams;
    throw error;
  }
};

const fetchJSON = async (url, fetchParams, options = {}) => {
  const text = await fetchText(url, fetchParams, options);
  let result;
  try {
    result = JSONbigString.parse(text);
  } catch (error) {
    logger.error('fetchJSON result parse failed', {operation: options.operation, error, text});
    throw error;
  }
  return result;
};

export default {
  fetchText,
  fetchJSON
};
